import {PostCancelLines, PostCancelLinesApiParameter } from "@dana/Services/DanaOrderRelatedService";
import { PostCancelLinesActions } from "@dana/Store/Data/OpenOrders/Reducers/PostCancelLinesReducer";
import { CancelOrderRequest, DanaPostCancelLinesResponse } from "@dana/Types/ApiModels";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnComplete,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { DispatchProp } from "react-redux";

type PostCancelLinesParameter = {
    cancelOrderRequest?:CancelOrderRequest;      
}& HasOnSuccess<any> & HasOnComplete<any> & HasOnError;


type HandlerType =ApiHandlerDiscreteParameter<PostCancelLinesParameter,PostCancelLinesApiParameter,DanaPostCancelLinesResponse, DispatchProp<PostCancelLinesActions>>;

export const SetLoadingOn: HandlerType = props => {
    props.dispatch?.({
        type: "CancelLines/IsLoading",
        isLoading: true,
    });
}

export const SendDataToApi: HandlerType = async props => {
const response = await PostCancelLines({
    cancelOrderRequest: props.parameter.cancelOrderRequest,
    });  
  props.apiResult=response;
  if (response?.success) {
     props.parameter.onSuccess?.(response);
  } 
};

export const PopulateFacetResult: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch?.({
            type: "CancelLines/PopulateResult",              
            data: props.apiResult,
        } as any);
    }    
}

export const chain = [SendDataToApi];

const PostCancelLinesData = createHandlerChainRunner(chain, "PostCancelLinesData");
export default PostCancelLinesData;